export default "__VITE_ASSET__BVLb0Kbn__"